.CommandPaletteInstructions {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 12px;
    padding: 10px 16px;
    border-top: 1px solid var(--soniq-t--global--border--color--card--default);
    flex-wrap: wrap;
}

.CommandPaletteInstructions__status {
    font-size: var(--soniq-t--global--font--size--date);
    font-family: var(--soniq-t--global--font--family--sans);
    color: var(--soniq-t--global--text--color--hint--default);
    line-height: 1.4;
}

.CommandPaletteInstructions__hints {
    display: flex;
    align-items: center;
    gap: 12px;
    flex-shrink: 0;
}

.CommandPaletteInstructions__hint {
    display: flex;
    align-items: center;
    gap: 4px;
    font-size: var(--soniq-t--global--font--size--date);
    font-family: var(--soniq-t--global--font--family--sans);
    color: var(--soniq-t--global--text--color--hint--default);
    line-height: 1.4;
}
